import { useHasActiveAnalyst } from '../hooks/use-has-active-analyst'

import type { PropsWithChildren } from 'react'

type HasActiveAnalystProps = PropsWithChildren<{
	fallback?: React.ReactNode
}>

/**
 * Renders children only if user has Analyst role AND active SKU
 */
export const HasActiveAnalyst = ({
	children,
	fallback,
}: HasActiveAnalystProps) => {
	const isActive = useHasActiveAnalyst()

	if (isActive) {
		return <>{children}</>
	}

	return fallback ?? null
}
